import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100px',
    height: '100px',
    background: 'rgb(60,60,60)',
    borderRadius: '50%',
    boxShadow: '0 0 10px rgb(60,60,60)',
    border: '10px solid rgb(50,50,50)',
  },
  pointer: {
    width: '40px',
    height: '40px',
    background: 'rgb(50,50,50)',
    borderRadius: '50%',
    marginLeft: '40%',
    boxShadow: '0 0 3px navajowhite',
  },
}));
interface IKnobProps {}

const Knob: React.FC<IKnobProps> = (props) => {
  const [rotation, setRotation] = useState(0);
  let xDirection = '';
  let yDirection = '';
  let oldX = 0;
  let oldY = 0;
  //Some random logic, have to change.
  const rotate = (e: any) => {
    if (oldX < e.pageX) {
      xDirection = 'right';
    } else {
      xDirection = 'left';
    }

    //deal with the vertical case
    if (oldY < e.pageY) {
      yDirection = 'down';
    } else {
      yDirection = 'up';
    }

    oldX = e.pageX;
    oldY = e.pageY;

    console.log(xDirection + ' ' + yDirection);

    let newRotation = rotation;
    if (yDirection === 'down') {
      newRotation = rotation + 3.6;
    } else if (yDirection === 'up') {
      newRotation = rotation - 3.6;
    }
    if (newRotation >= 360) {
      newRotation = -360;
    }
    setRotation(newRotation);
  };
  const classes = useStyles();
  return (
    <div
      id="knob"
      className={classes.root}
      style={{ transform: `rotate(${rotation}deg)` }}
      onMouseMove={rotate}
    >
      <div className={classes.pointer}></div>
    </div>
  );
};

export default Knob;
